// intakeApi.js

async function handleJsonResponse(res) {
  let data = null;

  try {
    data = await res.json();
  } catch {
    data = null;
  }

  if (!res.ok) {
    const message =
      data?.detail ||
      data?.message ||
      data?.error ||
      "Failed to submit intake.";
    throw new Error(message);
  }

  return data;
}

function normalizeArray(value) {
  if (!Array.isArray(value)) return [];
  return value.filter(Boolean);
}

export function buildIntakePayload(formState, selectedBodyRegions, currentLang = "en") {
  return {
    selected_regions: Array.isArray(selectedBodyRegions) ? selectedBodyRegions.filter(Boolean) : [],

    problem_main_type: formState.problem_main_type || "",
    problem_start_time: formState.problem_start_time || "",
    problem_onset_mode: formState.problem_onset_mode || "",
    problem_trend: formState.problem_trend || "",
    problem_severity_now: Number(formState.problem_severity_now ?? 1),
    problem_worse_by: Array.isArray(formState.problem_worse_by) ? formState.problem_worse_by : [],
    problem_better_by: Array.isArray(formState.problem_better_by) ? formState.problem_better_by : [],
    problem_function_limit: formState.problem_function_limit || null,

    rf_major_trauma: formState.rf_major_trauma === true,
    rf_recent_surgery: formState.rf_recent_surgery === true,
    rf_systemic_symptoms: formState.rf_systemic_symptoms === true,
    rf_unexplained_weight_loss: formState.rf_unexplained_weight_loss === true,
    rf_cancer_history: formState.rf_cancer_history === true,
    rf_constant_night_pain: formState.rf_constant_night_pain === true,
    rf_new_numbness_weakness: formState.rf_new_numbness_weakness === true,
    rf_bilateral_limb_symptoms: formState.rf_bilateral_limb_symptoms === true,
    rf_bowel_bladder_loss: formState.rf_bowel_bladder_loss === true,
    rf_saddle_anesthesia: formState.rf_saddle_anesthesia === true,
    rf_new_urine_control: formState.rf_new_urine_control === true,
    rf_fracture_risk: formState.rf_fracture_risk === true,
    rf_neuro_dizziness_vision: formState.rf_neuro_dizziness_vision === true,

    submission_lang: currentLang === "sl" ? "sl" : "en",
  };
}

export async function submitIntake({ formState, selectedBodyRegions, currentLang }) {
  const payload = buildIntakePayload(formState, selectedBodyRegions, currentLang);

  const res = await fetch("/py/intake/submit", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  return handleJsonResponse(res);
}

export async function getCurrentIntake() {
  const res = await fetch("/py/intake/current", {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });

  return handleJsonResponse(res);
}

export async function getCurrentConsent() {
  const res = await fetch("/py/intake/consent", {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });

  return handleJsonResponse(res);
}

export async function submitConsent(payload) {
  const res = await fetch("/py/intake/consent", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  return handleJsonResponse(res);
}